var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.649 0C2.979 0 .005 2.956.005 6.603s2.975 6.603 6.644 6.603a6.642 6.642 0 0 0 4.185-1.474l.02.023 4.057 4.058a.638.638 0 0 0 .902-.902l-4.058-4.058-.013-.01a6.552 6.552 0 0 0 1.551-4.24C13.293 2.956 10.318 0 6.649 0zm0 1.333c2.935 0 5.31 2.361 5.31 5.27 0 2.908-2.375 5.27-5.31 5.27-2.935 0-5.31-2.362-5.31-5.27 0-2.909 2.375-5.27 5.31-5.27z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4b1959e45f8e6d243577f7997c7dac65.svg";
export { ForwardRef as ReactComponent };